import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LookupModel } from 'infrastructure-shared';
import { Observable } from 'rxjs';
import {
    PerObjectDefinitionService,
} from '../../organization/object-management/object-definition/service/per-object-definition-service';
import { CodeTextService, PageCode } from 'humanresources-common-shared';
import { PerEmployeeSubtypeService, PerWorkSubareaService } from 'humanresources-general-shared';
import { PerPersonnelService } from '../../personnel-operations/service/per-personnel-service';
import { UiEnumService, UiTranslateLoaderService } from 'ui-shared';
import { HvlSecurityService } from '@hvlng/framework-bff/security';
import {
    OrganizationDefinitionModel,
} from '../../organization/organization-picker/model/organization-definition-model';
import { HvlPageable } from '@hvlng/framework-bff/core';
import {
    OrganizationDefinitionQueryModel,
} from '../../organization/organization-picker/model/organization-definition-query-model';
import { OrganizationDefinitionService } from '../../organization/service/organization-definition-service';

@Component({
    selector: 'personnel-picker-list-search-form',
    templateUrl: './personnel-picker-list-search-form.component.html',
})
export class PersonnelPickerListSearchFormComponent implements OnInit {
    employeeTypeList: Observable<LookupModel[]>;
    workAreaList: Observable<LookupModel[]>;
    posDefList;
    workSubareaList;
    employeeSubtypeList: Observable<LookupModel[]>;
    list;
    @Input() pageCode = PageCode.PERSONNEL_PICKER;
    @Input() form: UntypedFormGroup;
    @Output() valueEvent = new EventEmitter<any>();
    @Input() isClear: boolean;
    @Output() onBack = new EventEmitter();
    @Output() onSearch = new EventEmitter();

    @Input() activeFieldDisable;
    selectedModel;

    extSetting;
    enumTrueFalse = [];
    hasFullAuthority: boolean;
    topOrganizationList: OrganizationDefinitionModel[];
    searchingTopOrganization: boolean = false;
    @Input() isIdentityNumberRequired: boolean = false;
    @Input() showTopOrg = false;

    constructor(
        private codeTextService: CodeTextService,
        private workSubareaService: PerWorkSubareaService,
        private objectDefinitionService: PerObjectDefinitionService,
        private employeeSubtypeService: PerEmployeeSubtypeService,
        private personnelService: PerPersonnelService,
        private enumService: UiEnumService,
        private translateService: UiTranslateLoaderService,
        private securityService: HvlSecurityService,
        private organizationDefinitionService: OrganizationDefinitionService,
    ) {
    }

    ngOnInit(): void {
        this.hasFullAuthority = this.securityService.hasAuthority('kovan:hr:personnel:query');
        this.enumTrueFalse.push(
            {
                value: true,
                label: this.translateService.instant('hrCommon.usageStatusType.true'),
            },
            {
                value: false,
                label: this.translateService.instant('hrCommon.usageStatusType.false'),
            },
            {
                value: null,
                label: this.translateService.instant('hrPerCommon.all'),
            },
        );
    }

    onClear() {
        this.selectedModel = null;
        this.valueEvent.emit(null);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isClear?.currentValue) {
            this.onClear();
            this.onBack.emit();
        }
    }

    onKeyDownEvent(e) {
        this.onSearch.emit();
    }

    onRegNumAdd(e) {
        if (e.originalEvent.type == 'paste') {
            if (e.value && e.value.indexOf('\n') != -1) {
                this.form.get('registryNumber').setValue(e.value.split('\n').filter(item => item));
            }
        }
    }

    searchTopOrganization(searchText: string) {
        if (searchText.length < 1 || this.searchingTopOrganization) return;

        let queryModel = new OrganizationDefinitionQueryModel();
        queryModel.onlyTopLevel = true;
        queryModel.perObjectDefinitionText = searchText;
        let pageable = new HvlPageable();
        pageable.pageSize = 20;
        queryModel.pageable = pageable;
        this.searchingTopOrganization = true;
        this.organizationDefinitionService
            .queryOrganizationPage(queryModel)
            .subscribe((res) => (this.topOrganizationList = res.data))
            .add(() => (this.searchingTopOrganization = false));
    }
}
